/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_AdInputs */

const en_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic AD/DV`)
};

const fr_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicité automatique`)
};

const de_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Werbung`)
};

const it_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicità automatica`)
};

const ru_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая АЦП`)
};

const es_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD automático`)
};

const zh_cn2_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动广告`)
};

const ja_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動広告`)
};

const hi_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित एडी`)
};

const pt_pt2_automatic_ad = /** @type {(inputs: Automatic_AdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncio automático`)
};

/**
* | output |
* | --- |
* | "Automatic AD/DV" |
*
* @param {Automatic_AdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad = /** @type {((inputs?: Automatic_AdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_AdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_ad(inputs)
	if (locale === "de") return de_automatic_ad(inputs)
	if (locale === "it") return it_automatic_ad(inputs)
	if (locale === "ru") return ru_automatic_ad(inputs)
	if (locale === "es") return es_automatic_ad(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_ad(inputs)
	if (locale === "ja") return ja_automatic_ad(inputs)
	if (locale === "hi") return hi_automatic_ad(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_ad(inputs)
	return en_automatic_ad(inputs)
});